import React from "react";
import { useBrand } from "../../branding/BrandContext";

export default function Breadcrumbs({ items }) {
  const brand = useBrand();
  const list = Array.isArray(items) ? items : [];
  if (!list.length) return null;

  return (
    <nav aria-label="Breadcrumb" className="cl-breadcrumbs">
      <div className="cl-breadcrumbRow">
        {list.map((it, idx) => {
          const isLast = idx === list.length - 1;
          const label =
            idx === 0 && it?.href === "/"
              ? brand.brandName
              : it.label;
          return (
            <span key={`${it.label}-${idx}`} className="cl-crumb">
              {it.href && !isLast ? (
                <a href={it.href}>{label}</a>
              ) : (
                <span>{label}</span>
              )}
              {!isLast ? <span className="cl-crumbSep"> › </span> : null}
            </span>
          );
        })}
      </div>
    </nav>
  );
}
